import React, {Component} from 'react';
import {connect} from 'react-redux';
import CustomerAction from '../../actions/CustomerAction';
import Preloader from '../Preloader';
import ReactPaginate from 'react-paginate';

class Customers extends Component {

  state = {
    sorting: {
      field: '',
      direction: 'asc'
    },
    limit: 30
  };

  componentDidMount() {
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : 0}
    ];
    this.props.loadList(filter);
    this.props.getCustomerCount();
  }

  handlePageClick(data) {
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : data.selected * this.state.limit }
    ];
    if (this.state.sorting.field !== '') {
      filter.push({name: 'sort_by', value : this.state.sorting.field});
      filter.push({name: 'sort_dir', value : this.state.sorting.direction});
    }
    this.props.loadList(filter);
  }

  sortBy(fieldName) {
    var direction = this.state.sorting.direction === 'asc' ? 'desc' : 'asc';
    this.setState({
      sorting: {
        field: fieldName,
        direction: direction
      }
    });
    var filter = [
      {name: 'limit', value: this.state.limit},
      {name: 'offset', value : 0},
      {name: 'sort_by', value : fieldName},
      {name: 'sort_dir', value :direction}
    ];
    this.props.loadList(filter);
  }

  render() {
    var fieldName = this.state.sorting.field;
    var direction = this.state.sorting.direction === 'asc' ? 'fa fa-sort-asc' : 'fa fa-sort-desc';
    if (this.props.customers.length === 0 && this.props.isBusy) {
      return <Preloader />;
    } else {
      return <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Customers</h3>
              </div>
              <div className="panel-body">
                <table className="table table-condensed table-responsive table-nonfluid table-view">
                  <thead>
                  <tr>
                    <th className="bold">
                      <a onClick={() => this.sortBy('phone_number')}>
                        <i className={fieldName === 'phone_number' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                        &nbsp;Phone Number
                      </a>
                    </th>
                    <th className="bold">
                      <a onClick={() => this.sortBy('email')}>
                        <i className={fieldName === 'email' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                        &nbsp;Email
                      </a>
                    </th>
                    <th className="bold">
                      <a onClick={() => this.sortBy('name')}>
                        <i className={fieldName === 'name' ? direction : 'fa fa-sort'} aria-hidden="true"></i>
                        &nbsp;Name
                      </a>
                    </th>
                    <th className="bold">
                      Referral
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.props.customers.map((item, key) => {
                    return (
                      <tr key={key} className="form-group form-md-checkboxes">
                        <td>{item.phone_number}</td>
                        <td>{item.email}</td>
                        <td>{item.name}</td>
                        <td>{item.num_referred}</td>
                      </tr>
                    )
                  })}
                  {this.props.customers.length === 0 && !this.props.isBusy? <tr>
                    <td className="text-center" colSpan={6}>No data.</td>
                  </tr> : null}
                  <tr>
                    <td className="text-center absolute" colSpan={6}>
                      {this.props.isBusy ? <Preloader /> : null}
                    </td>
                  </tr>
                  </tbody>
                </table>
                {this.props.customerCount > this.state.limit ?
                <ReactPaginate previousLabel={"previous"}
                               nextLabel={"next"}
                               breakLabel={<a href="">...</a>}
                               breakClassName={"break-me"}
                               pageCount={Math.ceil(this.props.customerCount / this.state.limit)}
                               marginPagesDisplayed={2}
                               pageRangeDisplayed={5}
                               onPageChange={this.handlePageClick.bind(this)}
                               containerClassName={"pagination"}
                               subContainerClassName={"pages pagination"}
                               activeClassName={"active"} /> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}

export default connect(
  state => ({
    customers: state.customers,
    customerCount: state.customerCount,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    loadList: (filter) => {
      dispatch(CustomerAction.getList(filter));
    },
    getCustomerCount: () => {
      dispatch(CustomerAction.getCount());
    }
  })
)(Customers);



/** WEBPACK FOOTER **
 ** ./src/components/Customers/index.js
 **/